import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import {
  useGetPageDataQuery,
  useGetRisePlansQuery,
} from "../Store/api/CommonApi";
import { Link } from "react-router-dom";

function RisePlans() {
  const d = new Date();
  let year = d.getFullYear();
  const { data } = useGetPageDataQuery("rise-plans");
  const risePlans = useGetRisePlansQuery();
  const [plans, setPlans] = useState([]);
  const [plansName, setPlansName] = useState([]);

  const colors = useMemo(
    () => [
      "#fbced7",
      "#f38184",
      "#ffdb6e",
      "#ffff6e",
      "#6ec998",
      "#6ed2f7",
      "#b792c3",
    ],
    []
  );

  useEffect(() => {
    if (risePlans?.isSuccess) {
      setPlansName(risePlans?.data?.data);
    }
  }, [risePlans, setPlansName]);

  const rederCategory = useCallback(() => {
    var curIndex = -1;
    var catArray = [];
    for (let index = 0; index < plansName.length; index++) {
      if (colors[curIndex] === undefined) {
        curIndex = 0;
      }

      catArray.push(
        <div className="col-lg-4 col-md-6" key={index}>
          <Link
            to={
              "/partners/" +
              plansName[index]["plan_id"] +
              "/" +
              plansName[index]["plan_name"]
            }
          >
            <div
              className="single-service_vision text-center"
              style={{
                backgroundColor: colors[curIndex],
              }}
            >
              <h4>{plansName[index]["plan_name"]}</h4>
            </div>
          </Link>
        </div>
      );
      curIndex = curIndex + 1;
    }
    setPlans(catArray);
  }, [plansName, colors]);

  useEffect(() => {
    rederCategory();
  }, [rederCategory]);

  return (
    <Fragment>
      <PageBannerComponent
        title={data?.data?.heading ?? "Rise " + year}
        image={data?.data?.image}
      />
      {data?.data?.content !== "" && (
        <div className="container mt-4">
          <p dangerouslySetInnerHTML={{ __html: data?.data?.content }}></p>
        </div>
      )}

      {/* Start service Area */}
      <section className="service-area pt-5 section-gap" id="service">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-9 pb-40 header-text">
              <h1>RISE 2025 Parters</h1>
              <p>Reimagining Inclusion for Social Equity</p>
              <p>
                After six impactful editions of RISE – India’s Premier LGBT+ Job
                Fair, we are thrilled to announce the 7th edition (Virtual)
                scheduled for 10 May 2025.
                <br />
                <br />
                <i>RISE: Fostering Inclusion &amp; Transforming Lives</i>
                <br />
                <br />
                RISE is more than just a job fair; it's a movement dedicated to
                creating a more inclusive and equitable workplace for the LGBT+
                community. We believe that everyone deserves the opportunity to
                thrive in their careers without compromising their authentic
                selves.
              </p>
            </div>
          </div>
          <div className="row">{plans}</div>
        </div>
      </section>
      {/* End service Area */}
    </Fragment>
  );
}

export default RisePlans;
